import { Typography } from '@mui/material';
import { Container } from '@mui/system';
import React from 'react'
import { LayoutUnlogged } from '../../components/Common/LayoutUnlogged';

const Paragraph = (props) => {
  return (
    <Typography variant='body1' className='dark--text' mb={props.noSpace ? 0 : 2}>
      {props.children}
    </Typography>
  )
}

// const ItemList = (props) => {
//   return (
//     <li style={{listStyleType: props.order ? 'upper-roman' : 'disc', marginLeft: 24}} className='primary--text'>
//       <Paragraph noSpace>
//         {props.children}
//       </Paragraph>
//     </li>
//   )
// }

export const Privacity = () => {
  return (
    <LayoutUnlogged>
      <Container>
        <Typography
          variant='h5'
          component='h1'
          className='black--text bold-text'
          align='center'
          my={2}
        >
          Política de Privacidade - Eskala Dia das Crianças 2022
        </Typography>
        <Typography
          variant='h6'
          component='h2'
          className='black--text bold-text upper'
          my={2}
        >
          Segurança
        </Typography>
        <Paragraph>O site <a href="https://www.eskala.com.br/" target="_blank" rel="noreferrer" className='bold-text tertiary--text'>www.eskala.com.br</a>, respeita o sigilo e segurança de suas informações, sendo que todas as informações são criptografadas e mantidas em sigilo através de servidores seguros.</Paragraph>
        <Paragraph>Criptografia é o nome dado ao processo de codificação de informações, onde as informações são codificadas na origem e decodificadas no destino, dificultando que sejam decifradas durante o tráfego na internet.</Paragraph>
        <Paragraph>Ainda assim, você deve estar ciente de que as medidas de segurança relativas à internet, não são integralmente infalíveis.</Paragraph>
        <Paragraph>Todas as informações fornecidas por você em nosso site serão exclusivamente utilizadas unicamente para o procedimento de compra.</Paragraph>
        <Paragraph>As suas informações não serão disponibilizadas a terceiros, salvo mediante ordem judicial.</Paragraph>
        <Paragraph>Verifique a autenticidade de nosso site, junto ao certificado de segurança disponível no rodapé do site <a href="https://www.eskala.com.br/" target="_blank" rel="noreferrer" className='bold-text tertiary--text'>www.eskala.com.br</a>, e na barra verde, junto ao endereço HTTPS quando estiver realizando a compra.</Paragraph>
        
        <Typography
          variant='h6'
          component='h2'
          className='black--text bold-text upper'
          my={2}
        >
          Registro de dados
        </Typography>
        <Paragraph>Os dados fornecidos em nosso site serão registrados e armazenados em nosso banco de dados de forma automatizada e sem a intervenção humana, de modo que não serão armazenadas informações que não sejam necessárias à efetivação de sua compra no site.</Paragraph>
        <Paragraph>O uso do CPF é exigido por lei para a emissão de notas fiscais e para o envio das mercadorias compradas.</Paragraph>
        <Paragraph>Os e-mails e telefones disponibilizados, somente serão utilizados para contatos referentes às compras realizadas em nosso site.</Paragraph>
        <Paragraph>Enviaremos e-mails informando as promoções vigentes em nossa loja.</Paragraph>
        <Paragraph>Caso você não queira receber esses e-mails, poderá solicitar o não recebimento das mensagens de oferta.</Paragraph>
        <Paragraph>As senhas fornecidas por você serão arquivadas de maneira criptografada, permitindo que apenas o responsável pelo cadastro tenha acesso à senha.</Paragraph>
        <Paragraph>Portanto, você é inteiramente responsável pela guarda de suas senhas.</Paragraph>
        <Paragraph>Os números de cartões de crédito fornecidos serão registrados diretamente no banco de dados das administradoras de cartão, de modo que a Eskala não terá acesso a essas informações.</Paragraph>
        <Paragraph>Ao receber os dados do cartão, a administradora realizará a verificação da transação on-line, ocasião em que informará ao consumidor se a compra foi ou não liberada.</Paragraph>
      </Container>
    </LayoutUnlogged>
  )
}
